import { handleActions } from 'redux-actions';
import { apiModuleDefaultState, createApiActions } from './helpers';

export const actions = createApiActions('members');

const reducer = handleActions(
  {
    [actions.api.members.request]: () => ({
      isFetching: true,
      isError: false,
    }),
    [actions.api.members.response]: (_, { payload }) => ({
      isFetching: false,
      isError: false,
      data: payload,
    }),
    [actions.api.members.error]: (_, { payload }) => ({
      isFetching: false,
      isError: true,
      error: payload,
    }),
  },
  { ...apiModuleDefaultState, data: [], error: null }
);

export default reducer;
